
import React from 'react';
import { Bot } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { BotStatus, ColorScheme } from '@/types/trader';
import { iconColorMap, defaultIconStyles, statusStyles } from '@/components/premium-bots/utils/styles';
import { useTranslation } from 'react-i18next';

interface CardHeaderProps {
  name: string;
  status: BotStatus;
  type: string;
  colorScheme?: ColorScheme;
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  name,
  status,
  type,
  colorScheme
}) => {
  const iconStyle = colorScheme ? iconColorMap[colorScheme] : defaultIconStyles[type];
  const { t } = useTranslation();

  return (
    <div className="flex justify-between items-start mb-3">
      <div className="flex items-center space-x-2">
        <Bot className={iconStyle} size={20} />
        <h3 className="font-medium text-lg">{name}</h3>
      </div>
      <Badge variant="outline" className={cn("font-normal", statusStyles[status])}>
        {status === 'active' && (
          <span className="active-dot mr-1.5">
            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
          </span>
        )}
        {status === 'active'
          ? t('status_active')
          : t('status_inactive')}
      </Badge>
    </div>
  );
};
